import axios from 'axios';

const baseURL = "https://api.kabbajaj.com/api";

// Create axios instance with base configuration
const api = axios.create({
  baseURL: baseURL,
  timeout: 300000, // Increased timeout for production API
  withCredentials: true, // Enable credentials for cookie-based auth
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
}); 

// Request interceptor for debugging and CORS handling
api.interceptors.request.use(
  (config) => {
    // Log requests for debugging
    console.log(`Making ${config.method?.toUpperCase()} request to:`, config.url);

    // Ensure credentials are included for cookie-based auth
    config.withCredentials = true;

    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);
// Request interceptor to add auth token if available
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('adminToken');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    console.log(`✅ ${response.config.method?.toUpperCase()} ${response.config.url} - Status: ${response.status}`);
    return response;
  },
  (error) => {
    // Log detailed error information
    console.error('API Error:', {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      url: error.config?.url,
      method: error.config?.method
    });

    // Handle CORS errors
    if (error.code === 'ERR_NETWORK') {
      console.error('❌ Network error - possible CORS issue. Check if:');
      console.error('  1. Backend server is running');
      console.error('  2. Backend has CORS configured for this origin');
      console.error('  3. Backend allows credentials (cookies)');
    }

    // Handle authentication errors
    if (error.response?.status === 401) {
      console.error('❌ 401 Unauthorized - Authentication failed');
      console.error('  This usually means the JWT cookie is missing or invalid');

      // Clear auth data on 401 errors
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');

      // Dispatch logout event
      window.dispatchEvent(new CustomEvent('auth-logout'));
    }

    // Handle other HTTP errors
    if (error.response?.status >= 400) {
      console.error(`❌ HTTP ${error.response.status} Error:`, error.response.data);
    }

    return Promise.reject(error);
  }
);


export default api;